module.exports = __webpack_public_path__ + "static/media/maf-11.f86049b3.png";